module.exports = __webpack_public_path__ + "3f16e137/img/chevron-down-icon.5542f65c.svg";